import React, { useEffect, useState } from "react";
import ReportBugs from "@/assets/ReportBugs.png";
import ReportFirstIssue from "@/assets/NoReports.svg";
import { useWorkspaceStore } from "@/hooks/useWorkspace";
import useUserData from "@/hooks/useUserData";

const NoReports = () => {
  const { currentWorkspace } = useWorkspaceStore();
  const { user } = useUserData();
  const [extensionInstalled, setExtensionInstalled] = useState(false);
  const [checkingExtension, setCheckingExtension] = useState(true);

  useEffect(() => {
    const extensionId = "jjikojjfkjcbjklhldnjdnelfmjjmifg";

    // Set a timeout in case the message never gets a response
    const timeout = setTimeout(() => {
      // console.log("Extension check timed out - assuming not installed");
      setExtensionInstalled(false);
      setCheckingExtension(false);
    }, 1000);

    // Check if chrome API exists
    if (
      typeof (window as any).chrome !== "undefined" &&
      (window as any).chrome.runtime
    ) {
      try {
        (window as any).chrome.runtime.sendMessage(
          extensionId,
          { type: "ping" },
          (response: any) => {
            clearTimeout(timeout);
            if ((window as any).chrome.runtime.lastError) {
              // console.log(
              //   "Extension not installed:",
              //   (window as any).chrome.runtime.lastError.message
              // );
              setExtensionInstalled(false);
            } else {
              // console.log("Extension is installed:", response);
              setExtensionInstalled(true);
            }
            setCheckingExtension(false);
          }
        );
      } catch (error) {
        console.error("Error checking extension:", error);
        clearTimeout(timeout);
        setExtensionInstalled(false);
        setCheckingExtension(false);
      }
    } else {
      // Not Chrome or Chrome API not available
      // console.log("Chrome API not available");
      clearTimeout(timeout);
      setExtensionInstalled(false);
      setCheckingExtension(false);
    }

    return () => clearTimeout(timeout);
  }, []);

  if (!currentWorkspace?.users.map((user) => user._id).includes(user?._id)) {
    return;
  }

  if (checkingExtension) {
    return null;
  }

  return !extensionInstalled ? (
    <div className="flex flex-col w-[300px] items-center absolute text-center top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%]">
      <img className="w-[300px] h-[200px]" src={ReportBugs} />
      <div className="flex flex-col items-center px-[13px] pb-[32px]">
        <p className="mt-8 text-[20px] leading-[28px] font-medium">
          Ready to report bugs? Install our browser extension!
        </p>
        <p className="text-gray-800 mt-3 text-[14px] leading-[20px] font-medium">
          Install Toolbar and easily capture bugs directly from your browser
        </p>
        <a
          target="_blank"
          href="https://chromewebstore.google.com/detail/toolbar-bug-reports-with/jjikojjfkjcbjklhldnjdnelfmjjmifg"
          className="mt-8 h-[36px] px-3 flex items-center justify-center text-[14px] leading-[20px] font-medium bg-white hover:bg-white/[0.8] transition-all text-gray-50 rounded-[12px]"
        >
          Install Toolbar
        </a>
      </div>
    </div>
  ) : (
    <div className="flex flex-col items-center absolute text-center top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%]">
      <img className="w-[154px] h-[154px]" src={ReportFirstIssue} />
      <div className="flex flex-col items-center px-[13px] pb-[32px]">
        <p className="mt-8 text-[20px] leading-[28px] font-medium">
          It’s time to report your first issue!
        </p>
        <p className="w-[376px] text-gray-800 mt-3 text-[14px] leading-[20px] font-medium">
          You currently don't have any issues, but all issues from you and your
          team will appear here.
        </p>
      </div>
    </div>
  );
};

export default NoReports;
